// src/auth/LoginPage.js
import * as React from 'react';
import { useState } from 'react';
import { useLogin, useNotify, Notification } from 'react-admin';
import { Card, CardContent, TextField, Button, Typography, Box, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const LoginPage = () => {
    const [clinicId, setClinicId] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const login = useLogin();
    const notify = useNotify();

    const handleSubmit = (e) => {
        e.preventDefault();
        login({ username: clinicId, password }).catch(() =>
            notify('Неверный ID клиники или пароль', { type: 'error' })
        );
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault(); // Предотвращает потерю фокуса при клике на кнопку
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
            }}
        >
            <Card sx={{ minWidth: 300, maxWidth: 400 }}>
                <CardContent>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Вход в панель управления
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="ID клиники"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={clinicId}
                            onChange={(e) => setClinicId(e.target.value)}
                            required
                        />
                        <TextField
                            label="Пароль"
                            type={showPassword ? 'text' : 'password'}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ mt: 2 }}
                        >
                            Войти
                        </Button>
                    </form>
                </CardContent>
            </Card>
            <Notification />
        </Box>
    );
};

export default LoginPage;